var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:[`icon`, `icon-${_vm.type}`],attrs:{"role":_vm.ariaLabel ? 'img' : null,"aria-label":_vm.ariaLabel,"aria-hidden":!_vm.ariaLabel ? 'true' : null}})
}
var staticRenderFns = []

export { render, staticRenderFns }